var _defs, _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsappModern(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "whats",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#25D366"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#128C7E"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    rx: 56,
    fill: "url(#whats)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M128 52a76 76 0 0 0-65.7 114.6L56 204l38.9-6.3A76 76 0 1 0 128 52Zm0 138a62 62 0 0 1-31.8-8.8l-2.3-1.4-23.1 3.8 4-22.6-1.5-2.4a62 62 0 1 1 54.7 32.4Zm36.8-45.5c-2-1-11.8-5.8-13.6-6.5s-3.2-1-4.6 1c-1.4 2-5.3 6.5-6.5 7.8s-2.4 1.5-4.4.5-8.5-3.1-16.2-9.9c-6-5.4-10.1-12-11.3-14s-.1-3.1.9-4.1c1-1 2-2.5 3-3.8s1.4-2 .2-3.7c-1-1.7-4.6-11-6.3-15.1s-3.4-3.2-4.6-3.2-2.6-.2-4-.2-3.7.5-5.6 2.5c-2 2-7.4 7.2-7.4 17.6s7.5 20.4 8.5 21.8c1 1.4 14.7 22.5 36.2 31.5s21.6 7 25.5 6.6 12.5-5.1 14.3-10c1.8-5 1.8-9.2 1.2-10.2s-1.8-1.4-3.8-2.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappModern);
export default __webpack_public_path__ + "static/media/whatsapp-modern.06fb4b28a98e0046a5926f661c039f70.svg";
export { ForwardRef as ReactComponent };